import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { AngularFireDatabase, AngularFireList } from "angularfire2/database";
import { Observable } from "rxjs/Observable";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-results",
  templateUrl: "./results.component.html",
  styleUrls: ["./results.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class ResultsComponent implements OnInit {
  currentObj: any;
  overallResult: string;
  dd2proResultImg: string;
  art120ResultsImg: string;
  restulsUpdatedDate: string;
  overallResultsArt12: string;
  year: string;

  constructor(
    private afd: AngularFireDatabase,
    private activated: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activated.params.subscribe(routeParams => {
      this.year = routeParams.id;
      this.getResults(routeParams.id)
        .valueChanges()
        .subscribe(resultsObj => {
          console.log({resultsObj})
          this.currentObj = resultsObj;
          this.overallResult = this.currentObj.overall ? this.currentObj.overall.DD2_img : false;
          this.overallResultsArt12 = this.currentObj.overall.ART120_img;
          this.dd2proResultImg = this.currentObj.DD2PRO ? this.currentObj.DD2PRO.link : false;
          this.art120ResultsImg = this.currentObj.ART120.link;
          this.restulsUpdatedDate = this.currentObj.updated.date;
        });
    });
  }

  getResults(year) {
    let resultsObj = this.afd.object(`results/${year}`);
    return resultsObj;
  }

  folders = [
    {
      name: "all-season-results"
    }
  ];
}



// WEBPACK FOOTER //
// ./src/app/results/results.component.ts